
        import { initializeUI } from '/src/ui/uiInit.ts';
        
        document.addEventListener('DOMContentLoaded', () => {
            initializeUI();
            const overlay = document.getElementById('loading-overlay');
            const frames = overlay?.querySelectorAll('.man-frame');
            if (frames?.length) {
                let currentFrame = 0;
                setInterval(() => {
                    frames[currentFrame].classList.remove('active');
                    currentFrame = Math.floor(Math.random() * frames.length);
                    frames[currentFrame].classList.add('active');
                }, 250);
            }
        });
    